<template>
  <div
    :class="[
      'layout',
      'layout--login',
      'layout--padd',
      { 'layout--signup': activationPending }
    ]"
  >
    <Header header-text="The Product Focus Toolbox" />
    <HeaderBanner />
    <div class="u-width-wrapper">
      <div :class="['card', { 'card--fullwidth': activationPending }]">
        <NuxtPage />
      </div>
      <div v-if="!activationPending" class="card">
        <pageContent />
        <div
          v-if="$route.name === 'login'"
          class="btn-group btn-group--horizontal"
        >
          <nuxt-link class="btn" :to="{ name: 'signup' }"
            >Register for Free</nuxt-link
          >
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script setup lang="ts">
  const userStore = useUserStore();
  const activationPending = computed(() => userStore.status.activationPending);
</script>

<style lang="scss">
  .layout--login {
    .card {
      width: 50%;
      padding: 40px;
      display: flex;
      align-items: center;

      &:first-child {
        background-color: #f5f6f1;
      }
    }

    .u-width-wrapper {
      background: none;
      padding-top: 30px;
      padding-bottom: 30px;

      .card {
        flex-flow: column;
      }
    }

    .header {
      background: none;
      border: 0;
      position: relative;
      top: auto;
      left: auto;
      padding-bottom: 90px;

      @include respond-to-max("sm") {
        padding-bottom: 0;
      }

      .u-width-wrapper {
        background: none;

        @include respond-to-max("sm") {
          flex-direction: column;
        }
      }

      .logo {
        width: 150px;
        position: relative;
        left: auto;

        @include respond-to-max("sm") {
          width: 130px;
        }
      }
    }

    .header__background {
      top: 0;
    }

    .header__text {
      padding-top: 40px;
      margin-right: auto;
      margin-left: auto;
      place-self: flex-end flex-end;

      @include respond-to-max("sm") {
        padding-top: 20px;
      }

      p {
        font-size: 2.5rem;

        @include respond-to-max("sm") {
          font-size: 2.2rem;
        }
      }
    }
  }
</style>
